












import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class AppToggle extends Vue {
  @Prop() name: string;
  @Prop() label: string;
  @Prop() value: boolean;
  @Prop() error: string;
  @Prop({ default: false }) disabled: boolean;

  toggle: boolean = false;

  get errorMessage(): string | null {
    return this.error ? this.error : null;
  }

  @Watch("toggle")
  async watchToggle(val: boolean, oldVal: boolean) {
    this.$emit("input", val);
    this.$emit("change", val);
    this.$emit("onEditable");
  }
}
